import React, { useState, useEffect, useRef } from 'react';
import { 
  LockIcon, 
  User, FingerprintIcon,
  ChevronRight, RefreshCw,
  Plus, Loader2,
  ArrowLeft, 
  Shield, 
  FingerPrint, 
  Globe 
} from 'lucide-react';
import CreateAccount from './CreateAccout';
import ForgotPassword from './ForgotPassword';
import axios from 'axios';

import PrivacyPolicy from '../../a1m_adm/Land/Footer/PrivacyPolicy';
import TermsOfServiceModal from '../../a1m_adm/Land/Footer/TermsOfService';
import SecurityModal from '../../a1m_adm/Land/Footer/securityTerm';


const AdvancedSSO = () => {
  const [step, setStep] = useState('accounts');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isRedirecting, setIsRedirecting] = useState(false);
  const [error, setError] = useState('');
  const [existingAccounts, setExistingAccounts] = useState([]);
  const [redirectUri, setRedirectUri] = useState("");
  const emailInputRef = useRef(null);
  const [otp, setOTP] = useState(['', '', '', '', '', '']);
  const [countdown, setCountdown] = useState(60);
  const [canResend, setCanResend] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isResending, setIsResending ] = useState(false);
  const inputRefs = useRef([]);
  const [redirectUrl, setRedirectUrl] = useState(null);
  const [privacyPolicyModalOpen, setPrivacyPolicyModalOpen] = useState(false);
    const [termsOfServiceModalOpen, setTermsOfServiceModalOpen] = useState(false);
    const [securityModalOpen, setSecurityModalOpen] = useState(false);


  // Automatically focus next input when a digit is entered
  const handleOTPChange = (index, value) => {
    // Allow only numeric input
    if (!/^\d*$/.test(value)) return;
  
    const newOTP = [...otp];
    newOTP[index] = value;
    setOTP(newOTP);
  
    // Automatically move to the next input if a digit is entered
    if (value && index < 5) {
      inputRefs.current[index + 1].focus();
    }
  
    // Automatic submission when all 6 digits are entered
    if (index === 5 && value) {
      const otpValue = newOTP.join('');
      if (otpValue.length === 6) {
        handleOTPSubmit(otpValue);
      }
    }
  };

  const handleForgotPasswordClick = () => {
    // Capture the current URL (either /login or /CallbackSso)
    setRedirectUrl(window.location.pathname);
    setStep('forgotPassword');
  };
  
  const handleKeyDown = (index, e) => {
    // Handle backspace to move to the previous input
    if (e.key === 'Backspace' && !otp[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  // OTP Submission Handler
  // OTP Submission Handler
  const handleOTPSubmit = async (otpValue) => {
    if (isSubmitting) return;

    setIsSubmitting(true);
    setError('');

    try {
        const response = await fetch("/auth/verify-otp", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            credentials: "include",
            body: JSON.stringify({ token: otpValue })
        });

        const data = await response.json();

        if (response.ok && data.success) {
            // Fetch user profile after successful OTP verification
            await fetchUserProfile(); // Call function to fetch user profile
            window.location.href = data.redirect_uri || '/Landing';
        } else {
            setError(data.error || 'Verification failed. Please try again.');
            setOTP(['', '', '', '', '', '']); // Assuming you have this setOTA function
            inputRefs.current[0].focus();
            setTimeout(() => setError(''), 3000);
        }
    } catch (err) {
        setError('An error occurred. Please try again.');
        setTimeout(() => setError(''), 3000);
    } finally {
        setIsSubmitting(false);
    }
};

// Function to fetch user profile
const fetchUserProfile = async () => {
    const controller = new AbortController();
    try {
        const response = await axios.get('/users/me', {
            withCredentials: true,
            signal: controller.signal
        });      
        // Now save the user details locally if necessary
        saveAccountLocally(response.data.email, response.data.first_name, response.data.last_name);
    } catch (error) {
        if (axios.isCancel(error)) {
            //console.log('Request canceled:', error.message);
        } else {
            //console.error('Error fetching user profile:', error);
        }
    } finally {
        controller.abort();
    }
};

  // Manual OTP Submission Button
  const handleManualSubmit = () => {
    const otpValue = otp.join('');
    if (otpValue.length === 6) {
      handleOTPSubmit(otpValue);
    }
  };
  

  // Resend OTP Mechanism
  const handleResendOTP = async () => {
    if (!canResend) return;

    try {
        setIsResending(true);

        // Actually send an API call to resend the OTP
        const response = await fetch("/auth/resend-otp", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            credentials: "include"  // Ensure cookies, including HttpOnly, are sent
        });
        
        const data = await response.json();  // Parse the JSON response

        if (response.ok) {
            // Reset countdown and resend state upon success
            setCountdown(60);  // Start a new countdown timer
            setCanResend(false);
            
            // Optional: Show success message
            alert(data.message || 'New OTP sent successfully');
        } else {
            // Handle server error responses
            setError(data.error || 'Failed to resend OTP. Please try again.');setTimeout(() => {
              setError("");
            }, 5000);
        }
    } catch (err) {
        setError('Failed to resend OTP. Please try again.');
        setTimeout(() => {
          setError("");
        }, 5000);
    } finally {
        setIsResending(false);
    }
};

  // Countdown for OTP Resend
  useEffect(() => {
    const timer = countdown > 0 && setInterval(() => {
      setCountdown(prev => prev - 1);
    }, 1000);

    if (countdown === 0) {
      setCanResend(true);
    }

    return () => clearInterval(timer);
  }, [countdown]);

  // Check if OTP is complete
  const isOTPComplete = otp.every(digit => digit !== '');

  // Similar to previous implementation, we'll keep core logic the same
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);   
    const uri = params.get("redirect_uri") || "https://layerff.tech/landing";
    setRedirectUri(uri);

    const accounts = JSON.parse(localStorage.getItem("sso_accounts")) || [];
    setExistingAccounts(accounts);
  }, []);

  const getRandomColor = () => {
    const letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
};

   // Email submission handler
const handleEmailSubmit = async (e) => {
  e.preventDefault();

  // Trim the email to prevent leading/trailing spaces
  const trimmedEmail = email.trim();

  // Validate email: Check if empty or invalid
  if (!trimmedEmail) {
      setError("Email field cannot be empty.");
      return;
  }

  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailPattern.test(trimmedEmail)) {
      setError("Please enter a valid email address.");
      return;
  }

  setError(""); // Clear any previous error


  try {
      const response = await fetch("/auth/sso-authenticate-email", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email: trimmedEmail }),
      });

      const data = await response.json();
      if (response.ok) {
          setStep("password"); // Move to the next step
      } else {
          setError(data.error);
          setTimeout(() => {
            setError("");
          }, 5000);
      }
  } catch (error) {
      setError("Email verification failed");
      setTimeout(() => {
        setError("");
      }, 5000);
  }
};


// Modified handleExistingAccountClick function
const handleExistingAccountClick = async (email) => {
  try {
      const response = await fetch("/auth/sso-authenticate-email", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email, redirectUri }),
          credentials: "include"  // Ensure cookies are sent
      });

      const data = await response.json();
      if (response.ok) {
          // If the account exists, set the email and go to the password step
          setEmail(email);
          setStep('password');
          setError(''); // Clear any previous error
      } else {
          // If the account does not exist, alert the user and stay on email step
          setError(data.error || "Account not found. Please enter your email.");
          setTimeout(() => {
            setError("");
          }, 5000);
          //setError('Account not found');
      }
  } catch (error) {
    setError("An error occurred. Please try again.");
    setTimeout(() => {
      setError("");
    }, 5000);
  }
};


const handlePasswordSubmit = async (e) => {
  e.preventDefault();
  setIsRedirecting(true);

  try {
      const response = await fetch("/auth/sso-authenticate", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email, password, redirectUri }),
          credentials: "include"  // Ensure cookies are sent
      });

      const data = await response.json();  // Parse JSON response

      if (response.ok) {
          // Check for 2FA requirement in the response
          if (data.success && data.message === '2FA') {
              setStep('otp');  // Set the step to OTP input
          } else {
              // Store user details in localStorage BEFORE redirecting
              saveAccountLocally(data.email, data.first_name, data.last_name);

              // Redirect user to the destination app
              window.location.href = data.redirect_url;
          }
      } else {
          setError(data.error || "Login failed . Please try again.");
          setIsRedirecting(false);
          setTimeout(() => {
            setError("");
          }, 5000);
      }
  } catch (error) {
      //console.error('Login failed', error);
      setError("An error occurred. Please try again.");
      setIsRedirecting(false);
      setTimeout(() => {
        setError("");
      }, 5000);
  }
};
  
  
  // Function to store user data in localStorage
  const saveAccountLocally = (email, firstName, lastName) => {
      let accounts = JSON.parse(localStorage.getItem("sso_accounts")) || [];
  
      // Avoid duplicates
      if (!accounts.some((acc) => acc.email === email)) {
          accounts.push({
              email,
              name: `${firstName} ${lastName}`,
              color: getRandomColor(),
              initial: firstName.charAt(0).toUpperCase()
          });
  
          localStorage.setItem("sso_accounts", JSON.stringify(accounts));
      }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-slate-800 to-gray-900 flex items-center justify-center p-4 overflow-hidden">
      <div className="relative w-full max-w-6xl mx-auto">
        {/* Floating Animated Background Elements */}
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute top-1/4 left-1/4 w-64 h-64 bg-blue-500/10 rounded-full blur-3xl animate-pulse"></div>
          <div className="absolute bottom-1/4 right-1/4 w-72 h-72 bg-purple-500/10 rounded-full blur-3xl animate-pulse delay-500"></div>
        </div>        

        {/* Main Authentication Container */}
        <div className="relative z-10 bg-gray-900/80 backdrop-blur-2xl rounded-3xl shadow-2xl border border-gray-700/50 overflow-hidden grid md:grid-cols-2">
          {/* Left Branding & Illustration Section */}
          <div className="hidden md:flex flex-col justify-between p-12 bg-gradient-to-br from-gray-800 to-gray-900 border-r border-gray-700/30">
            <div className="space-y-6">
              <div className="flex items-center space-x-4">
                <Shield className="h-10 w-10 text-blue-500" strokeWidth={1.5} />
                <span className="text-3xl font-extralight tracking-wide text-white">
                  0x10LayerFF
                </span>
              </div>

              <div className="mt-16 space-y-4">
                <h2 className="text-4xl font-light text-gray-100 tracking-tight">
                  Secure Access. 
                  <br />
                  Seamless Experience.
                </h2>
                <p className="text-gray-400 text-lg font-light">
                  Advanced authentication with multi-factor protection and intelligent threat detection.
                </p>
              </div>
            </div>

            <div className="flex items-center space-x-4 text-gray-500">
              <FingerprintIcon className="h-6 w-6" />
              <Globe className="h-6 w-6" />
              <Shield className="h-6 w-6" />
            </div>
          </div>

          {/* Right Authentication Section */}
          <div className="relative p-12 flex flex-col justify-center">
            {/* Dynamic Navigation Back Button */}
            {step !== 'accounts' && (
              <button 
                onClick={() => setStep('accounts')}
                className="absolute top-6 left-6 p-2 hover:bg-gray-800 rounded-full transition-all group"
              >
                <ArrowLeft 
                  className="h-6 w-6 text-gray-400 group-hover:text-white transition-colors" 
                  strokeWidth={1.5} 
                />
              </button>
            )}

            {/* Accounts Selection Step */}
            {step === 'accounts' && (
              <div className="space-y-8">
                <h3 className="text-3xl font-light text-white tracking-tight">
                  Choose Your Account
                </h3>
                <p className="text-gray-400 mb-6">
                  Select an existing account or add a new one securely.
                </p>

                <div className="space-y-4">
                  {existingAccounts.map((account) => (
                    <div 
                      key={account.email} 
                      className="flex items-center bg-gray-800/50 hover:bg-gray-800/70 rounded-xl p-4 transition-all group cursor-pointer"
                      onClick={() => handleExistingAccountClick(account.email)}
                    >
                      <div 
                        className={`${account.color} w-16 h-16 rounded-xl flex items-center justify-center text-white font-semibold text-2xl shadow-lg`}
                      >
                        {account.initial}
                      </div>
                      <div className="ml-4 flex-grow">
                        <h4 className="text-white font-medium">{account.name}</h4>
                        <p className="text-gray-400 text-sm">{account.email}</p>
                      </div>
                      <ChevronRight 
                        className="text-gray-500 group-hover:text-white transition-colors" 
                        strokeWidth={1.5} 
                      />
                    </div>
                  ))}

                  <button 
                    onClick={() => setStep('email')}
                    className="w-full flex items-center justify-center p-4 bg-gray-800/50 hover:bg-gray-800/70 rounded-xl transition-all group"
                  >
                    <div className="w-12 h-12 rounded-xl border-2 border-dashed border-gray-600 flex items-center justify-center">
                      <Plus className="h-6 w-6 text-gray-400 group-hover:text-white transition-colors" />
                    </div>
                    <span className="ml-4 text-gray-400 group-hover:text-white">
                      Add New Account
                    </span>
                  </button>
                </div>
                
                        {/* Links to Create Account and Forgot Password */}
                        <div className="text-gray-400 text-sm flex justify-between">
                            <button onClick={handleForgotPasswordClick} className="hover:underline">Forgot Password?</button>
                            <button onClick={() => setStep("createAccount")} className="hover:underline">Create an Account</button>
                        </div>
              </div>
            )}

            {/* Create Account Form */}
            {step === "createAccount" && <CreateAccount onBack={() => setStep("login")} />}

            {/* Forgot Password Form */}
            {step === "forgotPassword" && (
              <ForgotPassword onBack={() => setStep("login")} redirectUrl={redirectUrl} />
            )}

            {/* Email Input Step */}
            {step === 'email' && (
              <form onSubmit={handleEmailSubmit} className="space-y-8">
                <h3 className="text-3xl font-light text-white tracking-tight">
                  Enter Your Email
                </h3>
                <p className="text-gray-400">
                  Provide your registered email to continue securely.
                </p>

                <div className="space-y-4">
                  <input 
                    ref={emailInputRef}
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="you@example.com"
                    className="w-full px-4 py-3 bg-gray-800/50 border border-gray-700/50 rounded-xl text-white focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                  />
                  {error && (
                    <p className="text-red-400 text-sm animate-pulse">
                      {error}
                    </p>
                  )}
                </div>

                <button 
                  type="submit"
                  className="w-full py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-xl transition-all font-medium"
                >
                  Continue
                </button>
              </form>
            )}

            {/* Password Input Step */}
            {step === 'password' && (
              <form onSubmit={handlePasswordSubmit} className="space-y-8">
                <h3 className="text-3xl font-light text-white tracking-tight">
                  Verify Identity
                </h3>
                <p className="text-gray-400">
                  Authenticate to access your secure workspace.
                </p>

                <div className="space-y-4">
                  <input 
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Enter your password"
                    className="w-full px-4 py-3 bg-gray-800/50 border border-gray-700/50 rounded-xl text-white focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                  />
                  {error && (
                    <p className="text-red-400 text-sm animate-pulse">
                      {error}
                    </p>
                  )}
                </div>

                <button 
                  type="submit"
                  disabled={isRedirecting}
                  className="w-full py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-xl transition-all font-medium disabled:opacity-50"
                >
                  {isRedirecting ? 'Authenticating...' : 'Sign In'}
                </button>
              </form>
            )}

            {step === 'otp' && (
              <div className="space-y-8 max-w-md mx-auto">
              <h3 className="text-3xl font-light text-white tracking-tight text-center">
                Two-Factor Authentication
              </h3>
              <p className="text-gray-400 text-center">
                Enter the 6-digit verification code sent to your email.
              </p>
        
              <div className="flex justify-center space-x-2">
                {otp.map((digit, index) => (
                  <input
                    key={index}
                    ref={(el) => (inputRefs.current[index] = el)}
                    type="text"
                    maxLength="1"
                    value={digit}
                    onChange={(e) => handleOTPChange(index, e.target.value)}
                    onKeyDown={(e) => handleKeyDown(index, e)}
                    className={`w-12 h-16 text-center text-2xl bg-gray-800/50 border-2 ${
                      otp.every((d) => d !== '') ? 'border-green-500 focus:ring-green-500' : 'border-gray-700 focus:border-blue-500'
                    } rounded-xl text-white focus:ring-2 focus:border-transparent transition-all`}
                    inputMode="numeric"
                    disabled={isSubmitting}
                  />
                ))}
              </div>;
        
              {error && (
                <p className="text-red-400 text-sm text-center animate-pulse">
                  {error}
                </p>
              )}
        
              <div className="space-y-4">
                {/* Manual Submit Button */}
                <button
                  onClick={handleManualSubmit}
                  disabled={otp.some((digit) => digit === '') || isSubmitting}
                  className={`w-full py-3 rounded-xl transition-all ${
                    otp.every((digit) => digit !== '') && !isSubmitting
                      ? 'bg-blue-600 hover:bg-blue-700 text-white'
                      : 'bg-gray-700 text-gray-400 cursor-not-allowed'
                  } flex items-center justify-center space-x-2`}
                >
                  {isSubmitting ? <Loader2 className="w-6 h-6 animate-spin" /> : <span>Verify OTP</span>}
                </button>;
        
                {/* Resend OTP Section */}
                <div className="flex justify-center items-center space-x-4 mt-4">
                  {!canResend ? (
                    <p className="text-gray-400">
                      Resend OTP in {countdown} seconds
                    </p>
                  ) : (
                    <button 
                      onClick={handleResendOTP}
                      disabled={isResending}
                      className={`
                        flex items-center space-x-2 
                        ${canResend && !isResending 
                          ? 'text-blue-400 hover:text-blue-300' 
                          : 'text-gray-500 cursor-not-allowed'}
                        transition-colors
                      `}
                    >
                      {isResending ? (
                        <Loader2 className="w-5 h-5 animate-spin" />
                      ) : (
                        <>
                          <RefreshCw className="w-5 h-5" />
                          <span>Resend OTP</span>
                        </>
                      )}
                    </button>
                  )}                  
                </div>
              </div>
            </div>
            )}
          </div>
        </div>

        {/* Footer */}
        <div className="mt-8 text-center text-gray-500 text-sm space-x-4">
                <a 
                    href="#" 
                    onClick={() => setPrivacyPolicyModalOpen(true)} 
                    className="hover:text-white transition-colors"
                >
                    Privacy
                </a>
                <a 
                    href="#" 
                    onClick={() => setTermsOfServiceModalOpen(true)} 
                    className="hover:text-white transition-colors"
                >
                    Terms
                </a>
                <a 
                    href="#" 
                    onClick={() => setSecurityModalOpen(true)} 
                    className="hover:text-white transition-colors"
                >
                    Security
                </a>
            </div>

            {/* Modal components */}
            <PrivacyPolicy
                privacyPolicyModalOpen={privacyPolicyModalOpen}
                setPrivacyPolicyModalOpen={setPrivacyPolicyModalOpen}
            />
            <TermsOfServiceModal
                termsOfServiceModalOpen={termsOfServiceModalOpen}
                setTermsOfServiceModalOpen={setTermsOfServiceModalOpen}
            />
            <SecurityModal
                securityModalOpen={securityModalOpen}
                setSecurityModalOpen={setSecurityModalOpen}
            />
      </div>
    </div>
  );
};

export default AdvancedSSO;
